import {Component} from '@angular/core';
import {EnvService} from "../../services/env.service";
import {HttpClient} from "@angular/common/http";
import {BaseComponent} from "../../base/base.component";
import {ActivatedRoute, Router, Params} from '@angular/router';
import {AlertService} from "../../services/alert.service";
import {AuthService} from "../../services/auth.service";

@Component({
  selector: 'micro-saCarrier-detail',
  templateUrl: './saCarrier-detail.component.html'
})
export class SaCarrierDetailComponent extends BaseComponent {
  saCarrier:any;

  constructor(protected env: EnvService,
              protected http: HttpClient,
              private route: ActivatedRoute,
              private router:Router,
              protected authService:AuthService,
              private alertService:AlertService) {
    super(env, http);
  }

  protected onInit(): void {
    this.route.params
      .subscribe((params: Params) => {
        let id:any = params['id'];
        if (id === '0') {
          this.createNew();
        } else {
          this.http.get(`${this.env.e.url}/access/saCarriers/${id}`).subscribe(
            data => {
              this.setSaCarrier(data);
            }
          );
        }
      });
  }

  setSaCarrier(saCarrier:any) {
    this.saCarrier = saCarrier;
  }

  createNew() {
    this.saCarrier = {
      saCarrierType: 'BLUELOCK',
      enabled: true
    };
  }

  get requiresCredentials() {
    return this.saCarrier.saCarrierType === 'BLUELOCK';
  }

  save() {
    if (!this.saCarrier.id) {
      this.http.post(`${this.env.e.url}/access/saCarriers`, this.saCarrier)
        .subscribe(
          data => {
            this.setSaCarrier(data)
            this.alertService.info(`Created ${this.saCarrier.name}`);
          }
        );
    } else {
      this.http.put(`${this.env.e.url}/access/saCarriers/${this.saCarrier.id}`, this.saCarrier)
        .subscribe(
          data => {
            this.setSaCarrier(data)
            this.alertService.info(`Updated`);
          }
        );
    }
  }

  delete() {
    this.http.delete(`${this.env.e.url}/access/saCarriers/${this.saCarrier.id}`)
      .subscribe(
        complete => {
          this.alertService.info(`Deleted ${this.saCarrier.name}`);
          this.router.navigate(["/sa/saCarriers"]);
        }
      );
  }
}
